var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagram3C71D0Ef(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    background: "transparent",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_177_1559)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 1.088C-.256 2.394 0 3.782 0 7.996c0 3.5-.61 7.009 2.586 7.835.998.257 9.84.257 10.838-.001 1.33-.344 2.413-1.423 2.56-3.305.022-.263.022-8.79 0-9.058-.157-2.005-1.391-3.16-3.017-3.394-.373-.054-.447-.07-2.36-.073C3.825.003 2.34-.3 1.002 1.088z",
    fill: "url(#paint0_linear_177_1559)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.998 2.093c-2.42 0-4.72-.216-5.597 2.038-.363.93-.31 2.139-.31 3.87 0 1.518-.05 2.946.31 3.869.876 2.255 3.193 2.039 5.596 2.039 2.318 0 4.708.24 5.596-2.04.364-.94.31-2.13.31-3.868 0-2.308.128-3.798-.992-4.917-1.133-1.133-2.666-.991-4.916-.991h.003zm-.53 1.064c5.05-.008 5.693-.57 5.338 7.229-.126 2.758-2.226 2.455-4.807 2.455-4.707 0-4.842-.134-4.842-4.843 0-4.763.373-4.838 4.312-4.842v.001zm3.683.98a.709.709 0 100 1.418.709.709 0 000-1.417zm-3.153.83a3.034 3.034 0 100 6.067 3.034 3.034 0 000-6.067zm0 1.064c2.603 0 2.607 3.939 0 3.939-2.603 0-2.607-3.939 0-3.939z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_177_1559",
    x1: 1.031,
    y1: 14.978,
    x2: 15.902,
    y2: 2.108,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FF543E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C837AB"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_177_1559"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    rx: 4,
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram3C71D0Ef);
export default __webpack_public_path__ + "static/media/instagram.3c71d0ef.25ecfd970f5d9034189cfc29d43b8e0b.svg";
export { ForwardRef as ReactComponent };